import { render, staticRenderFns } from "./idea.vue?vue&type=template&id=3817e075&scoped=true"
import script from "./idea.vue?vue&type=script&lang=js"
export * from "./idea.vue?vue&type=script&lang=js"
import style0 from "./idea.vue?vue&type=style&index=0&id=3817e075&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3817e075",
  null
  
)

export default component.exports